import { useEffect, useState } from "react";
import { EntrepotService } from "$services";
import GenericSelect, { GenericSelectProps } from "./GenericSelect";

type Props = {
  onChange: (companyId, company) => void;
  value: any;
  className?: string;
  error?: boolean;
  multiple?: boolean;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  token?: string;
};

function MonStockWarehouseSelect({
  disabled,
  className,
  label = "Code fournisseur",
  placeholder = "Sélectionnez un entrepôt",
  multiple = false,
  value,
  token = "",
  ...props
}: Props & Partial<GenericSelectProps>) {
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  useEffect(() => {
    const getWarehouses = async () => {
      if (token) {
        EntrepotService.getWMSWarehouses(token).then((res: any) => {
          setWarehouseOptions(res);
        });
      }
    };

    getWarehouses();
  }, [token]);

  const placeholderText =
    warehouseOptions?.length === 0 ? "Aucun entrepôt trouvé" : placeholder;

  return (
    <GenericSelect
      valueKey="label"
      className={className}
      label={label}
      placeholder={placeholderText}
      multiple={multiple}
      disabled={disabled || !warehouseOptions.length}
      options={warehouseOptions || []}
      value={value}
      {...props}
    />
  );
}

export default MonStockWarehouseSelect;
